export const version = "logger/5.5.0";
//# sourceMappingURL=_version.js.map